// extracted by mini-css-extract-plugin
export default {"main":"hz-components-page-loading-index-main"};